module.exports = __webpack_public_path__ + "img/white-paint-splash.fd25a72.png";